import AccessPoint from '@kalvi-education/kalvium-sdk/src/constants/AccessPoint.js'
import axios from 'axios'

import AxiosWithRetries from '@/utils/axiosRetry.js'

const createPendingFeedbackEntry = async (
    activeSlot,
    feedbackType,
    kalviumKc
) => {
    const payload = {
        type: feedbackType,
        slot_id: activeSlot.id,
        slot_start: activeSlot.startTime,
        slot_end: activeSlot.endTime,
        course_name: activeSlot.courseName,
        course_slug: activeSlot.courseSlug,
        lu_slug: activeSlot.luSlug,
        mentors: activeSlot.mentors,
        squad_number: activeSlot.squadNumber,
        email: kalviumKc?.getParsedToken()?.email,
        user_id: kalviumKc?.getParsedToken()?.sub,
    }

    axios
        .post(AccessPoint().feedback.feedbacks, payload, {
            headers: {
                Authorization: `Bearer ${kalviumKc.getToken()}`,
            },
        })
        .then(response => {
            return { success: true, data: response.data }
        })
        .catch(error => {
            console.error('Error creating feedback entry:', error)
        })
}

const getPendingFeedback = kalviumKc => {
    return axios
        .get(AccessPoint().feedback.feedbacks, {
            headers: {
                Authorization: `Bearer ${kalviumKc.getToken()}`,
            },
        })
        .then(response => {
            return response.data
        })
        .catch(error => {
            console.error(error)
        })
}

const submitFeedback = (feedbackData, kalviumKc) => {
    const axiosInstance = AxiosWithRetries(3)
    return axiosInstance
        .post(
            AccessPoint().feedback.feedback.replace(':id', feedbackData.id),
            feedbackData,
            {
                headers: {
                    Authorization: `Bearer ${kalviumKc.getToken()}`,
                },
            }
        )
        .then(response => {
            return { success: true, data: response.data }
        })
        .catch(error => {
            return error
        })
}

const isFeedbackEnabled = kalviumKc => {
    return axios
        .get(AccessPoint().security.metadata, {
            headers: {
                Authorization: `Bearer ${kalviumKc.getToken()}`,
            },
            params: {
                entity_id: 'global',
                entity_type: 'service',
            },
        })
        .then(response => {
            const metadata = response.data.list.find(
                item => item.key === 'is_feedback_enabled'
            )

            return metadata.value
        })
        .catch(error => {
            console.error('Error fetching metadata:', error)
            return false
        })
}

const isFeedbackAllowedPage = path => {
    return path === '/' || path.startsWith('/livebooks') || path.startsWith('/livebooks-legacy')
}

export {
    createPendingFeedbackEntry,
    getPendingFeedback,
    isFeedbackAllowedPage,
    isFeedbackEnabled,
    submitFeedback,
}
